import { get, set } from 'lodash';

import { ENTITY_TYPE, FIELD_PATHS, FIELD_VALUES, VISIT_CONTACT_TYPE } from '@funnels/constants';
import { FormValuesPostProductSelect, PostProductSelectContract, RelatedParty } from '@funnels/types';

import getIndexFromId from './getIndexFromId';
import { getPPSPropertyDisplayFields } from './getPPSPropertyDisplayFields';
import { INITIAL_VISIT_CONTACT_RELATED_PARTY } from './initialFormValues';

export function setPropertyRelatedPartyInitialValues(formValues: FormValuesPostProductSelect, applicationId: string) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const relatedParties = get(formValues, FIELD_PATHS.RELATED_PARTIES(), []) as RelatedParty[];
  const relatedPartiesToBeCreated: RelatedParty[] = [];

  postProductSelects
    .filter(
      (pps) => get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) === ENTITY_TYPE.ASSET
    )
    .forEach((pps) => {
      const assetId = get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_ID(0));
      const assetIndex = getIndexFromId(get(formValues, FIELD_PATHS.ASSETS()), assetId);
      const questions = get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_QUESTIONS(0));
      const assetRelatedPartyIndex = relatedParties.findIndex(
        (relatedParty) =>
          get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_ASSET_ID(0)) === assetId &&
          // make sure other type of related party (e.g. SOLICITOR) will not be included
          Object.values(VISIT_CONTACT_TYPE).includes(
            get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_TYPE(0))
          )
      );
      const { hasContactType } = getPPSPropertyDisplayFields(questions);
      // initialise related party for the property if it doesn't exists yet and
      // there is contact related question for this property
      // and there is permit asset
      if (assetRelatedPartyIndex === -1 && hasContactType && assetIndex !== -1) {
        const isNotToBePurchased = !get(formValues, FIELD_PATHS.ASSET_TO_BE_PURCHASED(assetIndex));
        const isOwnerOccupied =
          get(formValues, FIELD_PATHS.ASSET_PRIMARY_PURPOSE(assetIndex)) === FIELD_VALUES.OWNER_OCCUPIED;
        relatedPartiesToBeCreated.push({
          ...INITIAL_VISIT_CONTACT_RELATED_PARTY(applicationId, assetId),
          ...(isNotToBePurchased && isOwnerOccupied && { type: VISIT_CONTACT_TYPE.LoanParty }),
        });
      }
    });

  if (relatedPartiesToBeCreated.length > 0) {
    set(formValues, FIELD_PATHS.RELATED_PARTIES(), [...relatedParties, ...relatedPartiesToBeCreated]);
  }
}
